const WEBSITE_LANGUAGE_STORAGE_KEY = "conversso_website_language";

const WEBSITE_TRANSLATIONS = {
    es: {
        navbar: {
            home: "Inicio",
            how: "¿Cómo funciona?",
            solutions: "Soluciones",
            plans: "Planes",
            resources: "Recursos",
            about: "Nosotros",
            cta: "Agendar Demo",
            signin: "Iniciar sesión",
            langLabel: "ES",
            langAria: "Cambiar idioma a inglés",
        },
        hero: {
            title1: "Toda tu comunicación en un solo lugar.",
            title2: "Sin complicaciones",
            subtitle: "Converssoft centraliza",
            text1: "Organiza y optimiza la comunicación con clientes, proveedores y equipos internos desde",
            text2: "una sola plataforma",
            demo: "Agendar demo",
            seeHow: "Ver cómo funciona",
        },
        channels: {
            title1: "Así funciona",
            title2: "CONVERSSOFT",
            text1: "Conecta todos tus canales en un solo lugar,",
            text2: "responde desde un panel centralizado y analiza",
            text3: "métricas en tiempo real para optimizar cada",
            text4: "interacción y mejorar tus resultados.",
            button: "Ver más",
        },
        trust: {
            title: "Ellos ya confían en nosotros.",
            subtitle: "Empresas de todos los tamaños utilizan <strong>Converssoft</strong> para transformar su comunicación con clientes.",
        },
        dispersed: {
            title: "Cuando la comunicación se dispersa, el servicio pierde eficiencia",
            text1: "Correos electrónicos, WhatsApp, llamadas y mensajes internos",
            text2: "funcionan en canales aislados, sin conexión ni contexto",
            text3: "compartido.",
            lead: "Usa <strong>CONVERSSOFT</strong> y evita:",
            item1: "Respuestas tardías",
            item2: "Poca visibilidad sobre lo que realmente está pasando",
            item3: "Información duplicada",
            closing: "Recupera el control de tu comunicación con <strong>CONVERSSOFT</strong>",
        },
        stats: {
            title1: "¿Por qué importa la comunicación",
            title2: "Omnicanal?",
            subtitle: "La diferencia entre crecer o perder clientes está en cómo y cuándo respondes.",
            problem: "El problema",
            problemItem1: "Conversaciones perdidas entre canales desconectados.",
            problemItem2: "Tiempos de respuesta altos que frustran al cliente.",
            problemItem3: "Equipos sin visibilidad del historial ni contexto.",
            withConversso: "Con CONVERSSOFT",
            solutionItem1: "+40% de conversión al responder en menos de 5 min.",
            solutionItem2: "-60% en tiempo promedio de primera respuesta.",
            solutionItem3: "3x más retención gracias al seguimiento continuo.",
            metric1: "Conversión",
            metric2: "Tiempo de respuesta",
            metric3: "Retención de clientes",
        },
        connect: {
            title1: "CONVERSSOFT",
            title2: "lo conecta todo",
            text1: "Una plataforma omnicanal que permite a los equipos",
            text2: "gestionar conversaciones, colaborar y dar seguimiento sin",
            text3: "perder contexto.",
        },
        benefits: {
            title: "Beneficios clave",
            card1Title: "Centraliza todos tus canales de comunicación",
            card1Body: "Integra WhatsApp, redes sociales, correo y telefonía en una única bandeja de entrada. Gestiona todas las interacciones desde un solo lugar y evita que los mensajes se pierdan entre pestañas.",
            card2Title: "Mejora la colaboración entre equipos",
            card2Body: "Al facilitar conversaciones claras, seguimiento de acuerdos y acceso rápido a la información, los equipos pueden coordinarse mejor, reducir malentendidos y avanzar más rápido hacia sus objetivos. Con Converssoft, la colaboración se vuelve más organizada, transparente y efectiva.",
            card3Title: "Reduce tiempos de respuesta",
            card3Body: "Agiliza tu operación con respuestas rápidas, chatbots y enrutamiento inteligente. Asegura que cada cliente sea atendido por el agente correcto en el menor tiempo posible.",
            card4Title: "Mantén trazabilidad y control de cada conversación",
            card4Body: "Accede al historial completo de cada cliente y audita la calidad del servicio. Supervisa el desempeño de tu equipo con métricas claras y toma decisiones basadas en datos reales.",
        },
        how: {
            introTitle1: "Centraliza todos tus",
            introTitle2: "canales en un solo flujo",
            introText1: "Integra y gestiona todos tus canales de comunicación",
            introText2: "chat, correo electrónico, redes sociales y más desde una",
            introText3: "única plataforma omnicanal. Visualiza en tiempo real el",
            introText4: "estado de cada conversación, optimiza la distribución de",
            introText5: "tickets y ofrece una experiencia de atención al cliente ágil,",
            introText6: "coherente y sin interrupciones.",
            introCta: "Agendar demo",
            ticketsTitle: "Gestiona tus tickets",
            ticketsP1: "Conecta todos tus canales WhatsApp Bussines, Facebook, Instagram, Messenger, Correo electrónico, llamadas, videoconferencias y chat web directamente a la plataforma, sin migraciones complejas ni interrupciones en tu operación.",
            ticketsP2: "Centraliza cada interacción en un único sistema de gestión de tickets, donde puedes generar, asignar y dar seguimiento a solicitudes desde cualquier canal. Toda la información fluye hacia un panel unificado en tiempo real, permitiéndote mantener la operatividad de tus herramientas actuales mientras optimizas el control, la trazabilidad y la eficiencia de tu equipo de atención.",
            callsTitle: "Administra tus llamadas",
            callsP1: "Administra llamadas entrantes y salientes desde una misma plataforma, organizadas por campañas y vinculadas directamente a tus tickets. Atiende solicitudes en tiempo real, lleva un control detallado de cada interacción y mantén el historial completo del cliente en un solo lugar.",
            callsP2: "Supervisa la calidad del servicio mediante monitoreo de llamadas, realiza transferencias inmediatas al agente correspondiente o al que elija tu cliente y garantiza una atención ágil, profesional y sin interrupciones.",
            reportsTitle: "Control total de reportes y desempeño",
            reportsP1: "Supervisa el rendimiento de tus agentes y obtén visibilidad completa de tu operación con reportes detallados y en tiempo real. Analiza tiempos de respuesta, revisa información de tickets, correos electrónicos y plantillas enviadas, y accede a grabaciones de llamadas entrantes y salientes para evaluar la calidad del servicio.",
            reportsP2: "Toma decisiones basadas en datos, detecta oportunidades de mejora y optimiza continuamente la experiencia de atención al cliente.",
            interactionsTitle: "Gestiona tus interacciones con tus clientes mediante el CRM",
            interactionsP1: "Optimiza cada punto de contacto con tus clientes utilizando un sistema de CRM (Customer Relationship Management) que centraliza, organiza y potencia toda la información de tu negocio en un solo lugar. Registra llamadas, correos, reuniones y oportunidades de venta, logrando un seguimiento más estratégico, ordenado y profesional.",
            mobilityTitle: "Movilidad en aplicación móvil: Gestiona tus tickets desde cualquier lugar",
            mobilityP1: "Lleva el control total de tus tickets directamente desde tu celular con una aplicación móvil diseñada para brindarte agilidad y eficiencia en todo momento. No importa dónde te encuentres, podrás dar seguimiento, responder y gestionar solicitudes en tiempo real.",
            inviteTitle: "Únete hoy y da el siguiente paso hacia una gestión más eficiente.",
            inviteText: "Impulsa tu equipo hoy mismo con el plan que mejor se adapte a tus<br>necesidades. Comienza ahora y descubre cómo nuestra plataforma<br>puede optimizar tu trabajo, mejorar tu productividad y ofrecer mejores<br>resultados.",
            inviteContact: "Contactar a ventas",
            inviteDemo: "Demo",
            mockMyTickets: "Mis tickets",
            mockToday: "Hoy",
            mockAll: "Todos",
            mockSearch: "Buscar",
            mockOpen: "Abierto",
            mockClosed: "Cerrado",
            mockWaiting: "En espera 6624245958",
            mockInCallName: "En llamada Clarise Bones",
            mockAgents: "Agentes",
            mockInCall: "En llamada",
            mockBenefit1: "Control total de llamadas entrantes y salientes",
            mockBenefit2: "Vinculación automática con tickets",
            mockBenefit3: "Mejor experiencia del cliente",
            mockBenefit4: "Supervisión y mejora continua",
            mockBenefit5: "Mayor productividad del equipo",
            mockBenefit6: "Organización y reportes detallados",
            reportsBenefit1: "Mejora continua de la atención",
            reportsBenefit2: "Toma de decisiones basada en datos",
            reportsBenefit3: "Mayor eficiencia operativa",
            reportsBenefit4: "Control de la calidad del servicio",
            reportsBenefit5: "Historial completo y trazabilidad total de llamadas entrantes y salientes",
            interactionsBenefit1: "Módulo de agenda integrado.",
            interactionsBenefit2: "Kanban para gestión de proyectos.",
            interactionsBenefit3: "Prospección personalizada.",
            interactionsBenefit4: "Aumento de ventas.",
            interactionsBenefit5: "Optimización del tiempo.",
            interactionsBenefit6: "Mejor toma de decisiones.",
            interactionsBenefit7: "Trabajo colaborativo.",
            mobilityBenefit1: "Acceso inmediato.",
            mobilityBenefit2: "Respuestas en tiempo real.",
            mobilityBenefit3: "Notificaciones instantáneas.",
            mobilityBenefit4: "Seguimiento continuo.",
            mobilityBenefit5: "Mayor productividad.",
            mobilityBenefit6: "Mejor experiencia para el cliente.",
        },
        footer: {
            phoneLabel: "Teléfono",
            emailLabel: "Email",
            privacy: "Política de privacidad",
            terms: "Términos de servicio",
            copyright: "© 2026 Converssoft. Todos los derechos reservados.",
        },
    },
    en: {
        navbar: {
            home: "Home",
            how: "How It Works",
            solutions: "Solutions",
            plans: "Pricing",
            resources: "Resources",
            about: "About Us",
            cta: "Request a Demo",
            signin: "Sign in",
            langLabel: "EN",
            langAria: "Switch language to Spanish",
        },
        hero: {
            title1: "All your communication in one place.",
            title2: "Simple and seamless.",
            subtitle: "Converssoft brings everything together",
            text1: "Manage and optimize communication with customers, vendors, and internal teams from",
            text2: "a single platform.",
            demo: "Request a Demo",
            seeHow: "See How It Works",
        },
        channels: {
            title1: "How",
            title2: "CONVERSSOFT Works",
            text1: "Connect all your communication channels in one",
            text2: "place, respond from a centralized dashboard,",
            text3: "and track real-time metrics to improve",
            text4: "every interaction and drive better results.",
            button: "Learn More",
        },
        trust: {
            title: "Trusted by leading companies",
            subtitle: "Companies of all sizes use <strong>Converssoft</strong> to transform how they communicate with their customers.",
        },
        dispersed: {
            title: "When communication is scattered, service becomes inefficient",
            text1: "Emails, WhatsApp, calls, and internal messages",
            text2: "live in separate channels with no shared",
            text3: "context.",
            lead: "With <strong>CONVERSSOFT</strong>, you can avoid:",
            item1: "Slow response times",
            item2: "Lack of visibility into what is really happening.",
            item3: "Duplicate information",
            closing: "Take control of your communication with <strong>CONVERSSOFT</strong>",
        },
        stats: {
            title1: "Why Omnichannel Communication",
            title2: "Matters",
            subtitle: "The difference between growing and losing customers comes down to how and when you respond.",
            problem: "The problem",
            problemItem1: "Conversations lost across disconnected channels.",
            problemItem2: "Slow response times that frustrate customers.",
            problemItem3: "Teams with no visibility into conversation history or context.",
            withConversso: "With CONVERSSOFT",
            solutionItem1: "40% higher conversion when responding in under 5 minutes.",
            solutionItem2: "Less 60% reduction in average first response time.",
            solutionItem3: "3x higher customer retention through continuous follow-up.",
            metric1: "Higher Conversion",
            metric2: "Faster Response Time",
            metric3: "Customer Retention",
        },
        connect: {
            title1: "CONVERSSOFT",
            title2: "Connects Everything",
            text1: "An omnichannel platform that helps teams manage",
            text2: "conversations, collaborate, and follow up without",
            text3: "losing context.",
        },
        benefits: {
            title: "Key Benefits",
            card1Title: "Bring all your communication channels together",
            card1Body: "Integrate WhatsApp, social media, email, and telephony into one unified inbox. Manage every interaction from one place and prevent messages from getting lost across tabs.",
            card2Title: "Improve Team Collaboration",
            card2Body: "By enabling clearer conversations, agreement tracking, and faster access to information, teams coordinate better, reduce misunderstandings, and move faster toward their goals. With Converssoft, collaboration becomes more organized, transparent, and effective.",
            card3Title: "Reduce Response Times",
            card3Body: "Streamline your operation with fast replies, chatbots, and intelligent routing. Ensure every customer is handled by the right agent in the shortest possible time.",
            card4Title: "Maintain full visibility and control over every conversation",
            card4Body: "Access each customer’s full history and audit service quality. Track team performance with clear metrics and make data-driven decisions.",
        },
        how: {
            introTitle1: "Centralize all your",
            introTitle2: "channels in one workflow",
            introText1: "Integrate and manage all your communication channels",
            introText2: "chat, email, social media, and more from a",
            introText3: "single omnichannel platform. Monitor in real time",
            introText4: "the status of every conversation, optimize ticket",
            introText5: "distribution, and deliver an agile customer service",
            introText6: "experience with consistent, uninterrupted support.",
            introCta: "Request demo",
            ticketsTitle: "Manage your tickets",
            ticketsP1: "Connect all your channels WhatsApp Business, Facebook, Instagram, Messenger, email, calls, video calls, and web chat directly to the platform, with no complex migrations or interruptions to your operation.",
            ticketsP2: "Centralize every interaction in a single ticket management system where you can create, assign, and track requests from any channel. All information flows into a unified real-time dashboard, allowing you to keep your current tools running while improving control, traceability, and team efficiency.",
            callsTitle: "Manage your calls",
            callsP1: "Manage incoming and outgoing calls from one platform, organized by campaigns and directly linked to your tickets. Handle requests in real time, keep detailed control of every interaction, and maintain the complete customer history in one place.",
            callsP2: "Monitor service quality through call tracking, instantly transfer calls to the right agent or the one chosen by your customer, and ensure agile, professional, uninterrupted service.",
            reportsTitle: "Full control of reports and performance",
            reportsP1: "Monitor your agents' performance and gain complete visibility into your operation with detailed, real-time reports. Analyze response times, review ticket data, emails, and sent templates, and access recordings of incoming and outgoing calls to evaluate service quality.",
            reportsP2: "Make data-driven decisions, identify improvement opportunities, and continuously optimize the customer service experience.",
            interactionsTitle: "Manage your customer interactions through CRM",
            interactionsP1: "Optimize every customer touchpoint using a CRM (Customer Relationship Management) system that centralizes, organizes, and enhances all your business information in one place. Log calls, emails, meetings, and sales opportunities to achieve more strategic and professional follow-up.",
            mobilityTitle: "Mobile app mobility: Manage your tickets from anywhere",
            mobilityP1: "Take full control of your tickets directly from your phone with a mobile app designed to deliver agility and efficiency at all times. Wherever you are, you can track, respond to, and manage requests in real time.",
            inviteTitle: "Join today and take the next step toward more efficient management",
            inviteText: "Empower your team today with the plan that best fits your needs. Get<br>started now and discover how our platform can optimize your workflow,<br>improve productivity, and deliver better results.",
            inviteContact: "Contact Sales",
            inviteDemo: "Demo",
            mockMyTickets: "My tickets",
            mockToday: "Today",
            mockAll: "All",
            mockSearch: "Search",
            mockOpen: "Open",
            mockClosed: "Closed",
            mockWaiting: "On hold 6624245958",
            mockInCallName: "On call Clarise Bones",
            mockAgents: "Agents",
            mockInCall: "On call",
            mockBenefit1: "Full control of incoming and outgoing calls.",
            mockBenefit2: "Automatic ticket linking.",
            mockBenefit3: "Better customer experience.",
            mockBenefit4: "Continuous monitoring and improvement.",
            mockBenefit5: "Higher team productivity.",
            mockBenefit6: "Organization and detailed reporting.",
            reportsBenefit1: "Continuous service improvements.",
            reportsBenefit2: "Data-driven decision-making.",
            reportsBenefit3: "Greater operational efficiency.",
            reportsBenefit4: "Service quality control.",
            reportsBenefit5: "Complete history and full traceability of incoming and outgoing calls.",
            interactionsBenefit1: "Integrated calendar module.",
            interactionsBenefit2: "Kanban board for project management.",
            interactionsBenefit3: "Personalized prospecting.",
            interactionsBenefit4: "Time optimization.",
            interactionsBenefit5: "Better decision-making.",
            interactionsBenefit6: "Fully collaborative work.",
            interactionsBenefit7: "Sales growth.",
            mobilityBenefit1: "Instant access.",
            mobilityBenefit2: "Real-time responses.",
            mobilityBenefit3: "Instant notifications.",
            mobilityBenefit4: "Continuous tracking.",
            mobilityBenefit5: "Higher productivity.",
            mobilityBenefit6: "Better customer experience.",
        },
        footer: {
            phoneLabel: "Phone",
            emailLabel: "Email",
            privacy: "Privacy Policy",
            terms: "Terms of Service",
            copyright: "© 2026 Converssoft. All rights reserved.",
        },
    },
};

function setText(selector, value) {
    const element = document.querySelector(selector);
    if (!element || typeof value !== "string") return;
    element.textContent = value;
}

function setHtml(selector, value) {
    const element = document.querySelector(selector);
    if (!element || typeof value !== "string") return;
    element.innerHTML = value;
}

function setListItemText(selector, itemIndex, text) {
    const item = document.querySelectorAll(selector)[itemIndex];
    if (!item) return;
    const icon = item.querySelector("span");
    item.textContent = "";
    if (icon) {
        item.appendChild(icon);
        item.appendChild(document.createTextNode(" " + text));
    } else {
        item.textContent = text;
    }
}

function setInviteLines(lang) {
    const inviteTitle = document.querySelector(".website-how-invite__copy h2");
    const inviteText = document.querySelector(".website-how-invite__copy p");

    if (inviteTitle) {
        const titleLines =
            lang === "es"
                ? ["Únete hoy y da el siguiente", "paso hacia una gestión más", "eficiente."]
                : ["Join today and take the next step", "toward more efficient", "management."];

        inviteTitle.innerHTML = titleLines
            .map((line) => `<span class="website-how-invite__title-line">${line}</span>`)
            .join("");
    }

    if (inviteText) {
        const textLines =
            lang === "es"
                ? [
                      "Impulsa tu equipo hoy mismo con el plan que mejor se adapte a tus",
                      "necesidades. Comienza ahora y descubre cómo nuestra plataforma",
                      "puede optimizar tu trabajo, mejorar tu productividad y ofrecer mejores",
                      "resultados.",
                  ]
                : [
                      "Empower your team today with the plan that best fits your needs.",
                      "Get started now and discover how our platform can optimize your workflow,",
                      "improve productivity, and deliver better results.",
                  ];

        inviteText.innerHTML = textLines
            .map((line) => `<span class="website-how-invite__text-line">${line}</span>`)
            .join("");
    }
}

function applyWebsiteLanguage(lang) {
    const safeLang = lang === "en" ? "en" : "es";
    const t = WEBSITE_TRANSLATIONS[safeLang];

    document.documentElement.lang = safeLang;

    setText(".website-navbar__menu .website-navbar__link:nth-child(1)", t.navbar.home);
    setText(".website-navbar__menu .website-navbar__link:nth-child(2)", t.navbar.how);
    setText(".website-navbar__menu .website-navbar__link:nth-child(3)", t.navbar.plans);
    setText(".website-navbar__menu .website-navbar__link:nth-child(4)", t.navbar.about);
    setText(".website-navbar__cta", t.navbar.cta);
    setText(".website-navbar__signin", t.navbar.signin);
    setText("#website-lang-label", t.navbar.langLabel);

    const langToggle = document.getElementById("website-lang-toggle");
    if (langToggle) {
        langToggle.setAttribute("aria-label", t.navbar.langAria);
    }

    setText(".website-hero__title-line:nth-child(1)", t.hero.title1);
    setText(".website-hero__title-line:nth-child(2)", t.hero.title2);
    setText(".website-hero__subtitle", t.hero.subtitle);
    setText(".website-hero__text-line:nth-child(1)", t.hero.text1);
    setText(".website-hero__text-line:nth-child(2)", t.hero.text2);
    setText(".website-hero__btn--light", t.hero.demo);
    setText(".website-hero__btn--ghost", t.hero.seeHow);

    setText(".website-channels__title-line:nth-child(1)", t.channels.title1);
    setText(".website-channels__title-line:nth-child(2)", t.channels.title2);
    setText(".website-channels__text-line:nth-child(1)", t.channels.text1);
    setText(".website-channels__text-line:nth-child(2)", t.channels.text2);
    setText(".website-channels__text-line:nth-child(3)", t.channels.text3);
    setText(".website-channels__text-line:nth-child(4)", t.channels.text4);

    const channelsBtn = document.querySelector(".website-channels__btn");
    if (channelsBtn) {
        channelsBtn.innerHTML = `${t.channels.button} <span aria-hidden="true">↗</span>`;
    }

    setText(".website-trust__title", t.trust.title);
    setHtml(".website-trust__subtitle", t.trust.subtitle);

    setText(".website-dispersed__title", t.dispersed.title);
    setText(".website-dispersed__text-line:nth-child(1)", t.dispersed.text1);
    setText(".website-dispersed__text-line:nth-child(2)", t.dispersed.text2);
    setText(".website-dispersed__text-line:nth-child(3)", t.dispersed.text3);
    setHtml(".website-dispersed__lead", t.dispersed.lead);
    setListItemText(".website-dispersed__list li", 0, t.dispersed.item1);
    setListItemText(".website-dispersed__list li", 1, t.dispersed.item2);
    setListItemText(".website-dispersed__list li", 2, t.dispersed.item3);
    setHtml(".website-dispersed__closing", t.dispersed.closing);

    setText(".website-stats__title-line:nth-child(1)", t.stats.title1);
    setText(".website-stats__title-line:nth-child(2)", t.stats.title2);
    setText(".website-stats__subtitle", t.stats.subtitle);
    setText(".website-stats__card--problem .website-stats__card-title", t.stats.problem);
    setText(".website-stats__card--solution .website-stats__card-title", t.stats.withConversso);
    setListItemText(".website-stats__card--problem .website-stats__list li", 0, t.stats.problemItem1);
    setListItemText(".website-stats__card--problem .website-stats__list li", 1, t.stats.problemItem2);
    setListItemText(".website-stats__card--problem .website-stats__list li", 2, t.stats.problemItem3);
    setListItemText(".website-stats__card--solution .website-stats__list li", 0, t.stats.solutionItem1);
    setListItemText(".website-stats__card--solution .website-stats__list li", 1, t.stats.solutionItem2);
    setListItemText(".website-stats__card--solution .website-stats__list li", 2, t.stats.solutionItem3);
    setText(".website-stats__metric:nth-child(1) .website-stats__metric-label", t.stats.metric1);
    setText(".website-stats__metric:nth-child(2) .website-stats__metric-label", t.stats.metric2);
    setText(".website-stats__metric:nth-child(3) .website-stats__metric-label", t.stats.metric3);

    setText(".website-connect__title-line:nth-child(1)", t.connect.title1);
    setText(".website-connect__title-line:nth-child(2)", t.connect.title2);
    setText(".website-connect__text-line:nth-child(1)", t.connect.text1);
    setText(".website-connect__text-line:nth-child(2)", t.connect.text2);
    setText(".website-connect__text-line:nth-child(3)", t.connect.text3);

    setText(".website-benefits__title", t.benefits.title);
    setText(".website-benefits__card:nth-child(1) .website-benefits__card-title", t.benefits.card1Title);
    setText(".website-benefits__card:nth-child(2) .website-benefits__card-title", t.benefits.card2Title);
    setText(".website-benefits__card:nth-child(3) .website-benefits__card-title", t.benefits.card3Title);
    setText(".website-benefits__card:nth-child(4) .website-benefits__card-title", t.benefits.card4Title);
    setText(".website-benefits__card:nth-child(1) .website-benefits__face--back p", t.benefits.card1Body);
    setText(".website-benefits__card:nth-child(2) .website-benefits__face--back p", t.benefits.card2Body);
    setText(".website-benefits__card:nth-child(3) .website-benefits__face--back p", t.benefits.card3Body);
    setText(".website-benefits__card:nth-child(4) .website-benefits__face--back p", t.benefits.card4Body);

    setText(".website-how-intro__title-line:nth-child(1)", t.how.introTitle1);
    setText(".website-how-intro__title-line:nth-child(2)", t.how.introTitle2);
    setText(".website-how-intro__text-line:nth-child(1)", t.how.introText1);
    setText(".website-how-intro__text-line:nth-child(2)", t.how.introText2);
    setText(".website-how-intro__text-line:nth-child(3)", t.how.introText3);
    setText(".website-how-intro__text-line:nth-child(4)", t.how.introText4);
    setText(".website-how-intro__text-line:nth-child(5)", t.how.introText5);
    setText(".website-how-intro__text-line:nth-child(6)", t.how.introText6);
    setText(".website-how-intro__cta", t.how.introCta);

    setText(".website-how-tickets__panel-head h3", t.how.mockMyTickets);
    setText(".website-how-tickets__panel-tabs span:nth-child(1)", t.how.mockToday);
    setText(".website-how-tickets__panel-tabs span:nth-child(2)", t.how.mockAll);
    setText(".website-how-tickets__search", t.how.mockSearch);
    setText(".website-how-tickets__meta em", t.how.mockOpen);
    setText(".website-how-tickets__list li:nth-child(2) .website-how-tickets__meta em", t.how.mockOpen);
    setText(".website-how-tickets__list li:nth-child(3) .website-how-tickets__meta em", t.how.mockClosed);
    setText(".website-how-tickets__list li:nth-child(4) .website-how-tickets__meta em", t.how.mockClosed);
    setText(".website-how-tickets__card:nth-child(1) .website-how-tickets__card-meta em", t.how.mockOpen);
    setText(".website-how-tickets__card:nth-child(2) .website-how-tickets__card-meta em", t.how.mockOpen);
    setText(".website-how-tickets__card:nth-child(3) .website-how-tickets__card-meta em", t.how.mockOpen);
    setText(".website-how-tickets__card:nth-child(4) .website-how-tickets__card-meta em", t.how.mockOpen);
    setText(".website-how-tickets__copy h2", t.how.ticketsTitle);
    setText(".website-how-tickets__copy p:nth-of-type(1)", t.how.ticketsP1);
    setText(".website-how-tickets__copy p:nth-of-type(2)", t.how.ticketsP2);
    setListItemText(".website-how-tickets__benefits li", 0, t.how.mockBenefit1);
    setListItemText(".website-how-tickets__benefits li", 1, t.how.mockBenefit2);
    setListItemText(".website-how-tickets__benefits li", 2, t.how.mockBenefit3);
    setListItemText(".website-how-tickets__benefits li", 3, t.how.mockBenefit4);
    setListItemText(".website-how-tickets__benefits li", 4, t.how.mockBenefit5);
    setListItemText(".website-how-tickets__benefits li", 5, t.how.mockBenefit6);

    setText(".website-how-calls__copy h2", t.how.callsTitle);
    setText(".website-how-calls__copy p:nth-of-type(1)", t.how.callsP1);
    setText(".website-how-calls__copy p:nth-of-type(2)", t.how.callsP2);
    setListItemText(".website-how-calls__benefits li", 0, t.how.mockBenefit1);
    setListItemText(".website-how-calls__benefits li", 1, t.how.mockBenefit2);
    setListItemText(".website-how-calls__benefits li", 2, t.how.mockBenefit3);
    setListItemText(".website-how-calls__benefits li", 3, t.how.mockBenefit4);
    setListItemText(".website-how-calls__benefits li", 4, t.how.mockBenefit5);
    setListItemText(".website-how-calls__benefits li", 5, t.how.mockBenefit6);
    setText(".website-how-calls__status--waiting strong", t.how.mockWaiting);
    setText(".website-how-calls__status--active strong", t.how.mockInCallName);
    setText(".website-how-calls__agents-header h3", t.how.mockAgents);
    const callsSearch = document.querySelector(".website-how-calls__search");
    if (callsSearch) {
        callsSearch.innerHTML = `${t.how.mockSearch} <span class="material-symbols-outlined">search</span>`;
    }
    setText(".website-how-calls__call-card h4", t.how.mockInCall);
    setText(".website-how-calls__mini-ticket .website-how-calls__mini-meta em", t.how.mockOpen);

    setText(".website-how-reports__copy h2", t.how.reportsTitle);
    setText(".website-how-reports__copy p:nth-of-type(1)", t.how.reportsP1);
    setText(".website-how-reports__copy p:nth-of-type(2)", t.how.reportsP2);
    setListItemText(".website-how-reports__benefits li", 0, t.how.reportsBenefit1);
    setListItemText(".website-how-reports__benefits li", 1, t.how.reportsBenefit2);
    setListItemText(".website-how-reports__benefits li", 2, t.how.reportsBenefit3);
    setListItemText(".website-how-reports__benefits li", 3, t.how.reportsBenefit4);
    setListItemText(".website-how-reports__benefits li", 4, t.how.reportsBenefit5);

    setText(".website-how-interactions__copy h2", t.how.interactionsTitle);
    setText(".website-how-interactions__copy p", t.how.interactionsP1);
    setListItemText(".website-how-interactions__benefits li", 0, t.how.interactionsBenefit1);
    setListItemText(".website-how-interactions__benefits li", 1, t.how.interactionsBenefit2);
    setListItemText(".website-how-interactions__benefits li", 2, t.how.interactionsBenefit3);
    setListItemText(".website-how-interactions__benefits li", 3, t.how.interactionsBenefit4);
    setListItemText(".website-how-interactions__benefits li", 4, t.how.interactionsBenefit5);
    setListItemText(".website-how-interactions__benefits li", 5, t.how.interactionsBenefit6);
    setListItemText(".website-how-interactions__benefits li", 6, t.how.interactionsBenefit7);

    setText(".website-how-mobility__copy h2", t.how.mobilityTitle);
    setText(".website-how-mobility__copy p", t.how.mobilityP1);
    setListItemText(".website-how-mobility__benefits li", 0, t.how.mobilityBenefit1);
    setListItemText(".website-how-mobility__benefits li", 1, t.how.mobilityBenefit2);
    setListItemText(".website-how-mobility__benefits li", 2, t.how.mobilityBenefit3);
    setListItemText(".website-how-mobility__benefits li", 3, t.how.mobilityBenefit4);
    setListItemText(".website-how-mobility__benefits li", 4, t.how.mobilityBenefit5);
    setListItemText(".website-how-mobility__benefits li", 5, t.how.mobilityBenefit6);

    setInviteLines(safeLang);
    setText(".website-how-invite__btn--ghost", t.how.inviteContact);

    const inviteDemoBtn = document.querySelector(".website-how-invite__btn--demo");
    if (inviteDemoBtn) {
        inviteDemoBtn.innerHTML = `${t.how.inviteDemo} <span aria-hidden=\"true\">↗</span>`;
    }

    const footerContacts = document.querySelectorAll(".website-footer__contact");
    if (footerContacts[0]) {
        footerContacts[0].innerHTML = `<strong>${t.footer.phoneLabel}</strong> 800 0672496`;
    }
    if (footerContacts[1]) {
        footerContacts[1].innerHTML = `<strong>${t.footer.emailLabel}</strong> info@converssoft.com`;
    }

    setText(".website-footer__legal-links a:nth-child(1)", t.footer.privacy);
    setText(".website-footer__legal-links a:nth-child(2)", t.footer.terms);
    setText(".website-footer__copy", t.footer.copyright);
}

function setupWebsiteLanguageToggle() {
    const langToggle = document.getElementById("website-lang-toggle");
    if (!langToggle) return;

    const savedLanguage = window.localStorage.getItem(WEBSITE_LANGUAGE_STORAGE_KEY);
    const initialLanguage = savedLanguage === "en" ? "en" : "es";
    applyWebsiteLanguage(initialLanguage);

    langToggle.addEventListener("click", () => {
        const current = window.localStorage.getItem(WEBSITE_LANGUAGE_STORAGE_KEY) === "en" ? "en" : "es";
        const next = current === "es" ? "en" : "es";
        window.localStorage.setItem(WEBSITE_LANGUAGE_STORAGE_KEY, next);
        applyWebsiteLanguage(next);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupWebsiteLanguageToggle);
} else {
    setupWebsiteLanguageToggle();
}
